import React, { useEffect } from "react";
import { Table } from "antd";
import { useSupplierModel } from "../supplierModel";
import { IMdSupplierDetail } from "../supplierService";
import { ColumnsType } from "antd/es/table";

const columns: ColumnsType<IMdSupplierDetail> = [
    {
        align: "center",
        title: '版本',
        dataIndex: 'branch',
    }, {
        align: "center",
        title: '禁用',
        dataIndex: 'enable',
        render: v => v === 1 ? "否" : "是"
    }, {
        align: "center",
        title: '编码',
        width: 160,
        dataIndex: 'code',
    }, {
        align: "center",
        title: '名称',
        dataIndex: 'name',
    }, {
        align: "center",
        title: '类型编码',
        dataIndex: 'categoryCode',
    }, {
        align: "center",
        title: '类型名称',
        dataIndex: 'categoryName',
    }, {
        align: "center",
        title: '级别',
        dataIndex: 'level',
    }, {
        align: "center",
        title: '联系人',
        dataIndex: 'contact',
    }, {
        align: "center",
        title: '联系电话',
        dataIndex: 'phone',
    }, {
        align: "center",
        title: '办公电话',
        dataIndex: 'tel',
    }, {
        align: "center",
        title: '传真',
        dataIndex: 'fax',
    }, {
        align: "center",
        title: '邮箱',
        dataIndex: 'email',
    }, {
        align: "center",
        title: '网站',
        dataIndex: 'website',
    }, {
        align: "center",
        title: '地址',
        dataIndex: 'address',
    }, {
        align: "center",
        title: '发票抬头',
        dataIndex: 'invoiceHeader',
    }, {
        align: "center",
        title: '营业执照号',
        dataIndex: 'businessLicenseNo',
    }, {
        align: "center",
        title: '开户行',
        dataIndex: 'bank',
    }, {
        align: "center",
        title: '账号',
        dataIndex: 'bankAccount',
    }, {
        align: "center",
        title: '邮寄地址',
        dataIndex: 'postAddress',
    }, {
        align: "center",
        title: '法人',
        dataIndex: 'corporation',
    }, {
        align: "center",
        title: '经营范围',
        dataIndex: 'businessScope',
    }, {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        width: 60,
        render: (v) => v === 0 ? "正常" : "异常"
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },
];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useSupplierModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMdSupplierDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
